<template>
  <div
    class="mob-avatar"
    :style="{ 'background-color': customColor, color: textColor }"
  >
    <img v-if="img" :src="img" alt="Avatar" class="mob-avatar-img" />
    <span v-else class="mob-avatar-text">{{ textInitials }}</span>
  </div>
</template>

<script>
export default {
  name: "MobAvatar",
  props: {
    img: String,
    text: String,
  },
  data() {
    return {
      customColor: "text-neutral-700",
      textColor: "white",
    };
  },
  computed: {
    textInitials() {
      return this.text ? this.text.slice(0, 2).toUpperCase() : "";
    },
  },
  methods: {
    generateColor() {
      if (this.text) {
        const hash = this.hashCode(this.text);
        this.customColor = `#${this.intToRGB(hash)}`;

        const luminance = this.getLuminance(hash);
        this.textColor = luminance > 0.5 ? "black" : "white";
      }
    },
    hashCode(str) {
      let hash = 0;
      for (let i = 0; i < str.length; i++) {
        const char = str.charCodeAt(i);
        hash = (hash << 5) - hash + char;
        hash = hash & hash;
      }
      return hash;
    },
    intToRGB(int) {
      const char = (int & 0x00ffffff).toString(16).toUpperCase();
      return "00000".substring(0, 6 - char.length) + char;
    },
    hexToRGB(hex) {
      const r = parseInt(hex.slice(0, 2), 16);
      const g = parseInt(hex.slice(2, 4), 16);
      const b = parseInt(hex.slice(4, 6), 16);
      return [r, g, b];
    },
    getLuminance(hash) {
      const rgbColor = this.hexToRGB(this.intToRGB(hash));
      const [r, g, b] = rgbColor.map((c) => c / 255);

      const gammaCorrect = (c) => {
        const gamma = c / 12.92;
        return gamma <= 0.03928 ? gamma / 12.92 : ((c + 0.055) / 1.055) ** 2.4;
      };

      const linearR = gammaCorrect(r);
      const linearG = gammaCorrect(g);
      const linearB = gammaCorrect(b);

      return 0.2126 * linearR + 0.7152 * linearG + 0.0722 * linearB;
    },
  },
  watch: {
    text() {
      this.generateColor();
    },
  },
  mounted() {
    this.generateColor();
  },
};
</script>

<style>
.mob-avatar {
  @apply flex items-center justify-center w-8 h-8 rounded-full bg-blue-300 pointer-events-none;
}
</style>
